<template>
  <div>
    <page-header title="Security Policy" breadcrumb="Dashboard > Settings >> Security Policy" />

    <div class="custom-card">
      <div class="flex flex-col">
        <h3 class="font-bold text-lg mb-1">Password</h3>
        <div class="flex justify-between">
          <p>The same password strength are enforced for all users across the app. <a href="#"
              @click.prevent="showPolicyModal = true"> VIEW POLICY </a></p>
          <a href="" class="rounded p-2 font-thin w-48 text-center" style="border: 1px solid blue;"
            @click.prevent="showPasswordModal = true">Update Password</a>
        </div>
      </div>
      <div class="flex flex-col my-4">
        <h3 class="font-bold text-lg mb-1">Two Factor Authentication</h3>
        <div class="flex justify-between">
          <p class="flex">
            Two factor authentication enforced for all users within your domain.
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">Admin can enable 2FA for the <br /> rest of the users in any account. <br />When
                enabled
                users
                MUST set-up <br /> their 2FA in their next login.</div>
              <span>
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5 7H9.5V5H11.5V7ZM11.5 15H9.5V9H11.5V15ZM10.5 0C9.18678 0 7.88642 0.258658 6.67317 0.761205C5.45991 1.26375 4.35752 2.00035 3.42893 2.92893C1.55357 4.8043 0.5 7.34784 0.5 10C0.5 12.6522 1.55357 15.1957 3.42893 17.0711C4.35752 17.9997 5.45991 18.7362 6.67317 19.2388C7.88642 19.7413 9.18678 20 10.5 20C13.1522 20 15.6957 18.9464 17.5711 17.0711C19.4464 15.1957 20.5 12.6522 20.5 10C20.5 8.68678 20.2413 7.38642 19.7388 6.17317C19.2362 4.95991 18.4997 3.85752 17.5711 2.92893C16.6425 2.00035 15.5401 1.26375 14.3268 0.761205C13.1136 0.258658 11.8132 0 10.5 0Z"
                    fill="#383F51" />
                </svg>
              </span>
            </el-tooltip>
          </p>
          <a href="" class="rounded p-2 font-thin w-48 text-center" style="border: 1px solid blue;"
            @click.prevent="showTwoFactorModal = true">Configure</a>
        </div>
      </div>
      <!-- <div class="flex flex-col">
        <h3 class="font-bold text-lg mb-1">Security Question</h3>
        <div class="flex justify-between">  
          <p class="flex">
            Security questions not enforced for all users within your domain.
            <span>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.5 7H9.5V5H11.5V7ZM11.5 15H9.5V9H11.5V15ZM10.5 0C9.18678 0 7.88642 0.258658 6.67317 0.761205C5.45991 1.26375 4.35752 2.00035 3.42893 2.92893C1.55357 4.8043 0.5 7.34784 0.5 10C0.5 12.6522 1.55357 15.1957 3.42893 17.0711C4.35752 17.9997 5.45991 18.7362 6.67317 19.2388C7.88642 19.7413 9.18678 20 10.5 20C13.1522 20 15.6957 18.9464 17.5711 17.0711C19.4464 15.1957 20.5 12.6522 20.5 10C20.5 8.68678 20.2413 7.38642 19.7388 6.17317C19.2362 4.95991 18.4997 3.85752 17.5711 2.92893C16.6425 2.00035 15.5401 1.26375 14.3268 0.761205C13.1136 0.258658 11.8132 0 10.5 0Z" fill="#383F51"/>
            </svg>
            </span>
          </p>
          <a href="" class="rounded p-2 font-thin w-48 text-center" style="border: 1px solid blue;" @click.prevent="showSecurityQuestionModal  = true">Configure</a>
        </div>
      </div> -->
    </div>

    <update-password-modal :show-modal="showPasswordModal" @close-modal="showPasswordModal = false" />
    <password-policy-modal :show-modal="showPolicyModal" @close-modal="showPolicyModal = false" />

    <security-question-modal :show-modal="showSecurityQuestionModal" @close-modal="showSecurityQuestionModal = false" />
    <two-factor-modal :show-modal="showTwoFactorModal" @close-modal="showTwoFactorModal = false" />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import UpdatePasswordModal from "./Modals/UpdatePassordModal"
import SecurityQuestionModal from "./Modals/SecurityQuestionModal"
import TwoFactorModal from "./Modals/TwoFactorModal"
import PasswordPolicyModal from "./Modals/PasswordPolicyModal";

export default {
  components: {
    // SecurityPolicySettings,
    PageHeader,
    UpdatePasswordModal,
    TwoFactorModal,
    SecurityQuestionModal,
    PasswordPolicyModal
  },
  data() {
    return {
      showPolicyModal: false,
      showPasswordModal: false,
      showSecurityQuestionModal: false,
      showTwoFactorModal: false,

    }
  },
  mounted() {}
};
</script>

<style>
</style>
